function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function verifyEmail(_x, _x2, _x3) {
  return _verifyEmail.apply(this, arguments);
}
function _verifyEmail() {
  _verifyEmail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, email, publickey) {
    var message, signature, link, text, mail, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          message = "Request received for verification of email ".concat(email, " with publickey ").concat(publickey);
          _t = app.crypto;
          _t2 = message;
          _context.n = 1;
          return app.wallet.getPrivateKey();
        case 1:
          signature = _t.signMessage.call(_t, _t2, _context.v);
          link = "https://saito.io/saitosign?code=".concat(encodeURIComponent(signature));
          text = ['A request was made to verify this email address for SaitoSign document signing.', '', 'To verify your email address, click the link below:', '', link, '', 'If you are completing verification manually, enter the following code in SaitoSign:', '', signature, '', 'This verification link and code are intended only for the recipient of this email. If you did not request this verification, you can safely ignore this message.', '', 'Thanks,', 'SaitoSign'].join('\n');
          mail = app.modules.returnModule('MailRelay');
          mail.sendMail({
            to: email,
            from: 'SaitoSign <no-reply@saito.tech>',
            subject: 'Verify your email for SaitoSign',
            text: text,
            ishtml: false
          });
          return _context.a(2, {
            message: message,
            signature: signature
          });
      }
    }, _callee);
  }));
  return _verifyEmail.apply(this, arguments);
}
function verifyPhoto(_x4, _x5, _x6) {
  return _verifyPhoto.apply(this, arguments);
}
function _verifyPhoto() {
  _verifyPhoto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, publickey, image) {
    var photo, key, digest, message, signature, _t3, _t4;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          photo = String(image || '').trim();
          key = String(publickey || '').trim();
          if (!(!photo || !key)) {
            _context2.n = 1;
            break;
          }
          throw new Error('That photo could not be saved.');
        case 1:
          digest = app.crypto.hash(photo);
          message = "Photo received for verification of publickey ".concat(key, " with image ").concat(digest);
          _t3 = app.crypto;
          _t4 = message;
          _context2.n = 2;
          return app.wallet.getPrivateKey();
        case 2:
          signature = _t3.signMessage.call(_t3, _t4, _context2.v);
          return _context2.a(2, {
            method: 'photo',
            publickey: key,
            message: message,
            signature: signature,
            photo: photo
          });
      }
    }, _callee2);
  }));
  return _verifyPhoto.apply(this, arguments);
}
function verifyPassport(_x7, _x8, _x9) {
  return _verifyPassport.apply(this, arguments);
}
function _verifyPassport() {
  _verifyPassport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, publickey, image) {
    var documentImage, key, digest, message, signature, _t5, _t6;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          documentImage = String(image || '').trim();
          key = String(publickey || '').trim();
          if (!(!documentImage.startsWith('data:image/') || !key)) {
            _context3.n = 1;
            break;
          }
          throw new Error('That passport image could not be saved.');
        case 1:
          digest = app.crypto.hash(documentImage);
          message = "Passport image supplied for verification of publickey ".concat(key, " with image ").concat(digest);
          _t5 = app.crypto;
          _t6 = message;
          _context3.n = 2;
          return app.wallet.getPrivateKey();
        case 2:
          signature = _t5.signMessage.call(_t5, _t6, _context3.v);
          return _context3.a(2, {
            method: 'passport',
            publickey: key,
            message: message,
            signature: signature,
            image: documentImage
          });
      }
    }, _callee3);
  }));
  return _verifyPassport.apply(this, arguments);
}
function verifyEmailSignature(app, email, publickey, signature, serverkey) {
  var message = "Request received for verification of email ".concat(email, " with publickey ").concat(publickey);
  return app.crypto.verifyMessage(message, signature, serverkey);
}
function canonicalJSON(value) {
  if (value === null || _typeof(value) !== 'object') {
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    return '[' + value.map(function (item) {
      return canonicalJSON(item);
    }).join(',') + ']';
  }
  return '{' + Object.keys(value).sort().map(function (key) {
    return JSON.stringify(key) + ':' + canonicalJSON(value[key]);
  }).join(',') + '}';
}
function pdfPayload(pdf) {
  if (!Array.isArray(pdf)) {
    return [];
  }
  return pdf.map(function (entry) {
    return {
      name: String((entry === null || entry === void 0 ? void 0 : entry.name) || ''),
      pdf: String((entry === null || entry === void 0 ? void 0 : entry.pdf) || '')
    };
  });
}
function pdfHash(app, pdf) {
  return app.crypto.hash(canonicalJSON(pdfPayload(pdf)));
}
function signingConfigurationError(record) {
  var _record$document;
  if (!pdfPayload(record === null || record === void 0 || (_record$document = record.document) === null || _record$document === void 0 ? void 0 : _record$document.pdf).length) {
    return 'Add the PDF before finalizing this document.';
  }
  var actions = Array.isArray(record === null || record === void 0 ? void 0 : record.actions) ? record.actions : [];
  var users = Array.isArray(record === null || record === void 0 ? void 0 : record.users) ? record.users : [];
  var required = actions.filter(function (action) {
    return (action === null || action === void 0 ? void 0 : action.type) === 'signature' || (action === null || action === void 0 ? void 0 : action.type) === 'initial';
  });
  if (!required.length) {
    return 'Add at least one signature position before finalizing this document.';
  }
  var _iterator = _createForOfIteratorHelper(actions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var action = _step.value;
      if ((action === null || action === void 0 ? void 0 : action.type) !== 'signature' && (action === null || action === void 0 ? void 0 : action.type) !== 'initial' && (action === null || action === void 0 ? void 0 : action.type) !== 'date') {
        return 'Each signing action needs a valid type.';
      }
      if (!Number.isInteger(Number(action.id)) || Number(action.id) < 1 || !placedAction(action)) {
        return 'Each signing action needs a page and position.';
      }
      if (action.type !== 'signature' && action.type !== 'initial') {
        continue;
      }
      var user = users[Number(action.user)];
      if (!user) {
        return 'Assign a signer to every signature position.';
      }
      if (!String(user.name || '').trim() || !isEmailAddress(user.email)) {
        return 'Each signer needs a name and email address.';
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!(record !== null && record !== void 0 && record.metadata) || _typeof(record.metadata) !== 'object' || !record.metadata.verification) {
    return 'Choose how signers verify their identity before finalizing this document.';
  }
  return '';
}
function placedAction(action) {
  var page = Number(action === null || action === void 0 ? void 0 : action.page);
  var x = Number(action === null || action === void 0 ? void 0 : action.x);
  var y = Number(action === null || action === void 0 ? void 0 : action.y);
  var width = Number(action === null || action === void 0 ? void 0 : action.width);
  var height = Number(action === null || action === void 0 ? void 0 : action.height);
  return Number.isInteger(page) && page >= 1 && [x, y, width, height].every(function (value) {
    return Number.isFinite(value) && value >= 0 && value <= 1;
  }) && width > 0 && height > 0;
}
function actionPayload(action) {
  var next = {
    id: Number(action.id),
    type: action.type,
    user: Number(action.user),
    page: Number(action.page),
    x: Number(action.x),
    y: Number(action.y),
    width: Number(action.width),
    height: Number(action.height)
  };
  var group = String((action === null || action === void 0 ? void 0 : action.group) || '').trim();
  if (group) {
    next.group = group;
  }
  return next;
}
function finalizationPayload(app, record) {
  var _record$document2, _record$document3, _record$document4, _record$document5, _record$document6;
  var creator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : record === null || record === void 0 ? void 0 : record.creator;
  return {
    version: 1,
    creator: String(creator || '').trim(),
    document: {
      name: (record === null || record === void 0 || (_record$document2 = record.document) === null || _record$document2 === void 0 ? void 0 : _record$document2.name) || '',
      pdf_hash: pdfHash(app, record === null || record === void 0 || (_record$document3 = record.document) === null || _record$document3 === void 0 ? void 0 : _record$document3.pdf),
      page_count: Number(record === null || record === void 0 || (_record$document4 = record.document) === null || _record$document4 === void 0 ? void 0 : _record$document4.page_count) || 0,
      page_width: Number(record === null || record === void 0 || (_record$document5 = record.document) === null || _record$document5 === void 0 ? void 0 : _record$document5.page_width) || 0,
      page_height: Number(record === null || record === void 0 || (_record$document6 = record.document) === null || _record$document6 === void 0 ? void 0 : _record$document6.page_height) || 0
    },
    users: ((record === null || record === void 0 ? void 0 : record.users) || []).map(function (user) {
      return {
        name: String((user === null || user === void 0 ? void 0 : user.name) || '').trim()
      };
    }),
    actions: ((record === null || record === void 0 ? void 0 : record.actions) || []).map(actionPayload),
    metadata: (record === null || record === void 0 ? void 0 : record.metadata) || null
  };
}
function creatorProofPayload(app, record) {
  var _record$document7;
  var creator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : record === null || record === void 0 ? void 0 : record.creator;
  var finalized = (record === null || record === void 0 ? void 0 : record.finalized) === true;
  return {
    version: 1,
    creator: String(creator || '').trim(),
    pdf_hash: pdfHash(app, record === null || record === void 0 || (_record$document7 = record.document) === null || _record$document7 === void 0 ? void 0 : _record$document7.pdf),
    finalized: finalized,
    contract_hash: finalized ? app.crypto.hash(canonicalJSON(finalizationPayload(app, record, creator))) : ''
  };
}
function createCreatorProof(_x0, _x1) {
  return _createCreatorProof.apply(this, arguments);
}
function _createCreatorProof() {
  _createCreatorProof = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, record) {
    var _record$document11;
    var creator,
      publickey,
      privateKey,
      payload,
      _args4 = arguments;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          creator = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : record === null || record === void 0 ? void 0 : record.creator;
          publickey = String(creator || '').trim();
          if (!(!publickey || !pdfPayload(record === null || record === void 0 || (_record$document11 = record.document) === null || _record$document11 === void 0 ? void 0 : _record$document11.pdf).length)) {
            _context4.n = 1;
            break;
          }
          return _context4.a(2, false);
        case 1:
          _context4.n = 2;
          return app.wallet.getPrivateKey();
        case 2:
          privateKey = _context4.v;
          payload = creatorProofPayload(app, record, publickey);
          record.creatorProof = {
            version: 1,
            creator: publickey,
            finalized: payload.finalized,
            contract_hash: payload.contract_hash,
            signature: app.crypto.signMessage(canonicalJSON(payload), privateKey)
          };
          return _context4.a(2, true);
      }
    }, _callee4);
  }));
  return _createCreatorProof.apply(this, arguments);
}
function verifyCreatorProof(app, record) {
  var proof = record === null || record === void 0 ? void 0 : record.creatorProof;
  var creator = String((record === null || record === void 0 ? void 0 : record.creator) || '').trim();
  return Boolean(creator && (proof === null || proof === void 0 ? void 0 : proof.version) === 1 && String(proof.creator || '').trim() === creator && (
  // Earlier SaitoSign builds signed this payload but omitted these duplicated
  // metadata fields from the proof object. Treat those legacy omissions as
  // their signed payload values so editable creator drafts remain usable.
  proof.finalized === undefined || proof.finalized === (record.finalized === true)) && (proof.contract_hash === undefined || String(proof.contract_hash) === creatorProofPayload(app, record, creator).contract_hash) && proof.signature && app.crypto.verifyMessage(canonicalJSON(creatorProofPayload(app, record, creator)), proof.signature, creator));
}
function finalizeDocument(_x10, _x11, _x12) {
  return _finalizeDocument.apply(this, arguments);
}
function _finalizeDocument() {
  _finalizeDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, record, creator) {
    var publickey, privateKey, signature;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          publickey = String(creator || '').trim();
          if (!(!publickey || !record || record.finalized || signingConfigurationError(record))) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2, false);
        case 1:
          record.creator = publickey;
          record.hash = documentHash(app, record);
          _context5.n = 2;
          return app.wallet.getPrivateKey();
        case 2:
          privateKey = _context5.v;
          signature = app.crypto.signMessage(canonicalJSON(finalizationPayload(app, record, publickey)), privateKey);
          record.finalization = {
            version: 1,
            creator: publickey,
            signature: signature
          };
          record.finalized = true;
          _context5.n = 3;
          return createCreatorProof(app, record, publickey);
        case 3:
          record.edited = true;
          return _context5.a(2, true);
      }
    }, _callee5);
  }));
  return _finalizeDocument.apply(this, arguments);
}
function unfinalizeDocument(_x13, _x14) {
  return _unfinalizeDocument.apply(this, arguments);
}
function _unfinalizeDocument() {
  _unfinalizeDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, record) {
    var creator, previous, proved;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          creator = String((record === null || record === void 0 ? void 0 : record.creator) || '').trim();
          if (!(!(record !== null && record !== void 0 && record.finalized) || !creator || !walletKeys(app).includes(creator))) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, false);
        case 1:
          if (!(!verifyCreatorProof(app, record) || !verifyFinalization(app, record))) {
            _context6.n = 2;
            break;
          }
          return _context6.a(2, false);
        case 2:
          previous = {
            finalized: record.finalized,
            finalization: record.finalization,
            creatorProof: record.creatorProof ? JSON.parse(JSON.stringify(record.creatorProof)) : null,
            hash: String(record.hash || ''),
            signatures: (record.users || []).map(function (user) {
              return (user.signatures || []).map(function (entry) {
                return _objectSpread({}, entry);
              });
            })
          };
          record.finalized = false;
          record.finalization = null;
          record.hash = '';
          (record.users || []).forEach(function (user) {
            user.signatures = [];
          });
          record.edited = true;
          _context6.n = 3;
          return createCreatorProof(app, record, creator);
        case 3:
          proved = _context6.v;
          if (!(!proved || record.finalized || !verifyCreatorProof(app, record))) {
            _context6.n = 4;
            break;
          }
          record.finalized = previous.finalized;
          record.finalization = previous.finalization;
          record.creatorProof = previous.creatorProof;
          record.hash = previous.hash;
          (record.users || []).forEach(function (user, index) {
            user.signatures = previous.signatures[index] || [];
          });
          return _context6.a(2, false);
        case 4:
          return _context6.a(2, true);
      }
    }, _callee6);
  }));
  return _unfinalizeDocument.apply(this, arguments);
}
function verifyFinalization(app, record) {
  var finalization = record === null || record === void 0 ? void 0 : record.finalization;
  var creator = String((record === null || record === void 0 ? void 0 : record.creator) || '').trim();
  return Boolean((record === null || record === void 0 ? void 0 : record.finalized) === true && (finalization === null || finalization === void 0 ? void 0 : finalization.version) === 1 && creator && String(finalization.creator || '').trim() === creator && finalization.signature && app.crypto.verifyMessage(canonicalJSON(finalizationPayload(app, record, creator)), finalization.signature, creator));
}
function signAction(app, action, privateKey, documentHashValue) {
  var commitment = String(documentHashValue || '').trim();
  if (!commitment) {
    return null;
  }
  var payload = _objectSpread(_objectSpread({}, actionPayload(action)), {}, {
    document_hash: commitment
  });
  var signature = app.crypto.signMessage(canonicalJSON(payload), privateKey);
  return {
    id: payload.id,
    signature: signature,
    document_hash: commitment
  };
}
function actionSignature(user, action) {
  var found = signatureEntry(user, action);
  return typeof (found === null || found === void 0 ? void 0 : found.signature) === 'string' ? found.signature : '';
}
function signatureEntry(user, action) {
  var id = Number(action === null || action === void 0 ? void 0 : action.id);
  var list = Array.isArray(user === null || user === void 0 ? void 0 : user.signatures) ? user.signatures : [];
  return list.find(function (entry) {
    return Number(entry === null || entry === void 0 ? void 0 : entry.id) === id;
  }) || null;
}
function addSignature(app, action, privateKey, documentHashValue) {
  return signAction(app, _objectSpread(_objectSpread({}, action), {}, {
    type: 'signature'
  }), privateKey, documentHashValue);
}
function addInitial(app, action, privateKey, documentHashValue) {
  return signAction(app, _objectSpread(_objectSpread({}, action), {}, {
    type: 'initial'
  }), privateKey, documentHashValue);
}
function verifyActionSignature(app, action, user, record) {
  var publicKey = String((user === null || user === void 0 ? void 0 : user.publickey) || '');
  var entry = signatureEntry(user, action);
  var expected = String((record === null || record === void 0 ? void 0 : record.hash) || '').trim();
  if (!action || !(entry !== null && entry !== void 0 && entry.signature) || !publicKey || !commitmentIntact(app, record)) {
    return false;
  }
  if (action.type !== 'signature' && action.type !== 'initial') {
    return false;
  }
  if (String(entry.document_hash || '') !== expected) {
    return false;
  }
  var payload = _objectSpread(_objectSpread({}, actionPayload(action)), {}, {
    document_hash: expected
  });
  return app.crypto.verifyMessage(canonicalJSON(payload), entry.signature, publicKey);
}
function requiredActions(actions) {
  return (actions || []).filter(function (action) {
    return action.type === 'signature' || action.type === 'initial';
  });
}
function userActionsSigned(app, actions, users, userIndex, record) {
  var user = users === null || users === void 0 ? void 0 : users[userIndex];
  return requiredActions(actions).filter(function (action) {
    return action.user === userIndex;
  }).every(function (action) {
    return verifyActionSignature(app, action, user, record);
  });
}
function allActionsSigned(app, actions, users, record) {
  return requiredActions(actions).every(function (action) {
    return verifyActionSignature(app, action, users === null || users === void 0 ? void 0 : users[action.user], record);
  });
}
function actionStatus(app, actions, users, userIndex, record) {
  var required = requiredActions(actions);
  var signed = required.filter(function (action) {
    return verifyActionSignature(app, action, users === null || users === void 0 ? void 0 : users[action.user], record);
  }).length;
  var mine = required.filter(function (action) {
    return action.user === userIndex;
  });
  var mineSigned = mine.filter(function (action) {
    return verifyActionSignature(app, action, users === null || users === void 0 ? void 0 : users[userIndex], record);
  }).length;
  return {
    required: required.length,
    signed: signed,
    remaining: required.length - signed,
    mine: mine.length,
    mineSigned: mineSigned,
    userComplete: mineSigned === mine.length,
    complete: signed === required.length
  };
}
function isEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}
function nameFromEmail(email) {
  return String(email).split('@')[0].replace(/[._+-]+/g, ' ').replace(/\s+/g, ' ').trim();
}
function walletKeys(app) {
  var _app$wallet, _app$crypto;
  var raw = String(((_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.publicKey) || '').trim();
  var keys = [];
  if (raw) {
    keys.push(raw);
  }
  if (/^[0-9a-fA-F]+$/.test(raw) && raw.length >= 64 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.compressPublicKey) {
    var compressed = app.crypto.compressPublicKey(raw);
    if (compressed && !keys.includes(compressed)) {
      keys.push(compressed);
    }
  }
  return keys;
}
function emailOnKey(stored) {
  var email = String((stored === null || stored === void 0 ? void 0 : stored.email) || '').trim();
  if (isEmailAddress(email)) {
    return email;
  }
  var identifier = String((stored === null || stored === void 0 ? void 0 : stored.identifier) || '').trim();
  if (isEmailAddress(identifier)) {
    return identifier;
  }
  return '';
}
function knownSigner(app, signers) {
  var list = Array.isArray(signers) ? signers : [];
  var keys = walletKeys(app);
  var byKey = list.filter(function (signer) {
    var key = String((signer === null || signer === void 0 ? void 0 : signer.publickey) || (signer === null || signer === void 0 ? void 0 : signer.publicKey) || '').trim();
    return Boolean(key) && keys.includes(key);
  });
  if (byKey.length === 1) {
    return byKey[0];
  }
  return null;
}
function myKeychainEmail(app) {
  if (!app.keychain) {
    return null;
  }
  var _iterator2 = _createForOfIteratorHelper(walletKeys(app)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var publickey = _step2.value;
      var email = emailOnKey(app.keychain.returnKey(publickey, true));
      if (!email) {
        continue;
      }
      var keys = walletKeys(app);
      return {
        name: nameFromEmail(email) || email,
        email: email,
        publickey: keys[keys.length - 1]
      };
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return null;
}
function clearEmailIdentifier(app, publickey) {
  var _app$keychain$returnK;
  var key = String(publickey || '').trim();
  if (!(app !== null && app !== void 0 && app.keychain) || !key) {
    return;
  }
  var identifier = String(((_app$keychain$returnK = app.keychain.returnKey(key, true)) === null || _app$keychain$returnK === void 0 ? void 0 : _app$keychain$returnK.identifier) || '').trim();
  if (isEmailAddress(identifier)) {
    app.keychain.addKey(key, {
      identifier: ''
    });
  }
}
function rememberEmail(app, publickey, email) {
  var address = String(email || '').trim();
  var key = String(publickey || '').trim();
  if (!app.keychain || !key || !isEmailAddress(address)) {
    return;
  }
  var existing = app.keychain.returnKey(key, true);
  var data = {
    email: address
  };
  var identifier = String((existing === null || existing === void 0 ? void 0 : existing.identifier) || '').trim();
  if (isEmailAddress(identifier)) {
    data.identifier = '';
  }
  app.keychain.addKey(key, data);
}
function emailVerificationMessage(email, publickey) {
  return "Request received for verification of email ".concat(email, " with publickey ").concat(publickey);
}
function verificationMethod(entry) {
  var method = String((entry === null || entry === void 0 ? void 0 : entry.method) || '').trim();
  if (method) {
    return method;
  }
  return String((entry === null || entry === void 0 ? void 0 : entry.message) || '').startsWith('Request received for verification of email ') ? 'email' : '';
}
function validVerification(app, entry, user) {
  var email = String((user === null || user === void 0 ? void 0 : user.email) || '').trim();
  var publickey = String((user === null || user === void 0 ? void 0 : user.publickey) || '').trim();
  var method = verificationMethod(entry);
  if (!(entry !== null && entry !== void 0 && entry.signature) || !(entry !== null && entry !== void 0 && entry.message) || !(entry !== null && entry !== void 0 && entry.publickey) || !publickey) {
    return false;
  }
  if (method === 'email') {
    if (!isEmailAddress(email) || entry.message !== emailVerificationMessage(email, publickey)) {
      return false;
    }
    return app.crypto.verifyMessage(entry.message, entry.signature, entry.publickey);
  }
  if (method === 'photo') {
    var photo = String(entry.photo || '').trim();
    if (!photo || entry.publickey !== publickey) {
      return false;
    }
    var message = "Photo received for verification of publickey ".concat(publickey, " with image ").concat(app.crypto.hash(photo));
    return entry.message === message && app.crypto.verifyMessage(message, entry.signature, publickey);
  }
  if (method === 'passport') {
    var image = String(entry.image || '').trim();
    if (!image.startsWith('data:image/') || entry.publickey !== publickey) {
      return false;
    }
    var _message = "Passport image supplied for verification of publickey ".concat(publickey, " with image ").concat(app.crypto.hash(image));
    return entry.message === _message && app.crypto.verifyMessage(_message, entry.signature, publickey);
  }
  return false;
}
function requiredVerificationIds(record) {
  var metadata = (record === null || record === void 0 ? void 0 : record.metadata) || {};
  var tier = metadata.tier === 'premium' ? 'premium' : 'free';
  var verification = metadata.verification || {};
  var ids = [];
  if (verification.email !== false) {
    ids.push('email');
  }
  if (verification.photo === true) {
    ids.push('photo');
  }
  if (tier === 'premium' && verification.passport === true) {
    ids.push('passport');
  }
  if (tier === 'premium' && verification.phone === true) {
    ids.push('mobile');
  }
  if (tier === 'premium' && verification.legal_review === true) {
    ids.push('thirdParty');
  }
  return ids;
}
function verificationSatisfied(app, record, user) {
  var known = verifiedMethods(app, user);
  return requiredVerificationIds(record).every(function (id) {
    return known.includes(id);
  });
}
function verifiedMethods(app, user) {
  var entries = Array.isArray(user === null || user === void 0 ? void 0 : user.verifications) ? user.verifications : [];
  var found = [];
  entries.forEach(function (entry) {
    if (!validVerification(app, entry, user)) {
      return;
    }
    var method = verificationMethod(entry);
    if (method) {
      found.push(method);
    }
  });
  return found;
}
function verifiedEmail(app, user) {
  var email = String((user === null || user === void 0 ? void 0 : user.email) || '').trim();
  var publickey = String((user === null || user === void 0 ? void 0 : user.publickey) || '').trim();
  if (!isEmailAddress(email) || !publickey) {
    return '';
  }
  var entries = Array.isArray(user.verifications) ? user.verifications : [];
  var holds = entries.some(function (entry) {
    if (!(entry !== null && entry !== void 0 && entry.signature) || !(entry !== null && entry !== void 0 && entry.message) || !(entry !== null && entry !== void 0 && entry.publickey)) {
      return false;
    }
    return validVerification(app, entry, user) && verificationMethod(entry) === 'email';
  });
  return holds ? email : '';
}
function canonicalVerification(metadata) {
  var tier = (metadata === null || metadata === void 0 ? void 0 : metadata.tier) === 'premium' ? 'premium' : 'free';
  var verification = (metadata === null || metadata === void 0 ? void 0 : metadata.verification) || {};
  var next = {
    tier: tier,
    tier_owner: String((metadata === null || metadata === void 0 ? void 0 : metadata.tier_owner) || '').trim(),
    verification: {
      email: verification.email !== false,
      phone: tier === 'premium' && verification.phone === true,
      photo: verification.photo === true,
      passport: verification.passport === true,
      legal_review: tier === 'premium' && verification.legal_review === true
    }
  };
  if (tier === 'premium') {
    next.online_signing = metadata.online_signing === true;
    next.archive_contract = metadata.archive_contract === true;
  }
  return next;
}
function documentCommitment(record) {
  var _record$document8, _record$document9, _record$document0, _record$document1, _record$document10;
  var signers = ((record === null || record === void 0 ? void 0 : record.users) || []).map(function (user, index) {
    return {
      index: index,
      name: String((user === null || user === void 0 ? void 0 : user.name) || '').trim(),
      email: String((user === null || user === void 0 ? void 0 : user.email) || '').trim().toLowerCase()
    };
  });
  var actions = ((record === null || record === void 0 ? void 0 : record.actions) || []).map(function (action) {
    return actionPayload(action);
  }).sort(function (left, right) {
    return left.id - right.id;
  });
  return {
    version: 1,
    creator: String((record === null || record === void 0 ? void 0 : record.creator) || '').trim(),
    document: {
      name: String((record === null || record === void 0 || (_record$document8 = record.document) === null || _record$document8 === void 0 ? void 0 : _record$document8.name) || ''),
      pdf: pdfPayload(record === null || record === void 0 || (_record$document9 = record.document) === null || _record$document9 === void 0 ? void 0 : _record$document9.pdf),
      page_count: Number(record === null || record === void 0 || (_record$document0 = record.document) === null || _record$document0 === void 0 ? void 0 : _record$document0.page_count) || 0,
      page_width: Number(record === null || record === void 0 || (_record$document1 = record.document) === null || _record$document1 === void 0 ? void 0 : _record$document1.page_width) || 0,
      page_height: Number(record === null || record === void 0 || (_record$document10 = record.document) === null || _record$document10 === void 0 ? void 0 : _record$document10.page_height) || 0
    },
    signers: signers,
    actions: actions,
    verification: canonicalVerification(record === null || record === void 0 ? void 0 : record.metadata)
  };
}
function documentHash(app, record) {
  return app.crypto.hash(canonicalJSON(documentCommitment(record)));
}
function commitmentIntact(app, record) {
  var stored = String((record === null || record === void 0 ? void 0 : record.hash) || '').trim();
  return Boolean((record === null || record === void 0 ? void 0 : record.finalized) && stored && stored === documentHash(app, record));
}
function documentFullyVerified(app, record) {
  var required = requiredActions(record === null || record === void 0 ? void 0 : record.actions);
  return Boolean(required.length > 0 && commitmentIntact(app, record) && verifyFinalization(app, record) && allActionsSigned(app, record.actions, record.users, record));
}
function documentUnchanged(app, record) {
  var hash = String((record === null || record === void 0 ? void 0 : record.hash) || '');
  return Boolean(hash) && hash === documentHash(app, record);
}
function rememberVerifiedEmails(app, record) {
  var users = Array.isArray(record === null || record === void 0 ? void 0 : record.users) ? record.users : [];
  users.forEach(function (user) {
    var email = verifiedEmail(app, user);
    if (email) {
      rememberEmail(app, user.publickey, email);
    }
  });
}
module.exports = {
  verifyEmail: verifyEmail,
  verifyPhoto: verifyPhoto,
  verifyPassport: verifyPassport,
  verifyEmailSignature: verifyEmailSignature,
  addSignature: addSignature,
  addInitial: addInitial,
  verifyActionSignature: verifyActionSignature,
  finalizationPayload: finalizationPayload,
  createCreatorProof: createCreatorProof,
  verifyCreatorProof: verifyCreatorProof,
  finalizeDocument: finalizeDocument,
  unfinalizeDocument: unfinalizeDocument,
  verifyFinalization: verifyFinalization,
  documentHash: documentHash,
  documentUnchanged: documentUnchanged,
  commitmentIntact: commitmentIntact,
  documentFullyVerified: documentFullyVerified,
  signingConfigurationError: signingConfigurationError,
  userActionsSigned: userActionsSigned,
  allActionsSigned: allActionsSigned,
  actionStatus: actionStatus,
  myKeychainEmail: myKeychainEmail,
  knownSigner: knownSigner,
  clearEmailIdentifier: clearEmailIdentifier,
  rememberEmail: rememberEmail,
  rememberVerifiedEmails: rememberVerifiedEmails,
  verifiedMethods: verifiedMethods,
  verifiedEmail: verifiedEmail,
  verificationSatisfied: verificationSatisfied,
  validVerification: validVerification
};